import { render, staticRenderFns } from "./CustomSwiper.vue?vue&type=template&id=77e7836e"
import script from "./CustomSwiper.vue?vue&type=script&lang=js"
export * from "./CustomSwiper.vue?vue&type=script&lang=js"
import style0 from "./CustomSwiper.vue?vue&type=style&index=0&id=77e7836e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports